












































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Swiper from './Swiper.vue';
import Title from './Title.vue';
import Gallery from '@/components/gallery/Gallery.vue';
import Twoimgs from './Twoimgs.vue';
import Threenews from './Threenews.vue';
import KnowMoreBtn from '@/components/know-more-button/Know-more-btn.vue';

import axios from 'axios';
import {
  getProductsUrl,
  getExhibitionUrl,
  getTestingUrl,
  getMaterialUrl,
} from '@/util/lang.ts';

import imgs from '@/util/imgs.ts';

@Component({
  components: {
    Swiper,
    Title,
    Gallery,
    Twoimgs,
    Threenews,
    KnowMoreBtn,
  },
})
export default class Home extends Vue {
  private imgs = imgs;
  private products: object[] = [];
  private exhibitionInfos: object[] = [];
  private reportInfos: object[] = [];
  private dataInfos: object[] = [];

  private showVideo = false;

  @Watch('$store.state.lang')
  private onLangChanged() {
    this.fetchData();
  }

  // lifecycle hook
  private mounted() {
    this.$nextTick(() => {
      this.fetchUI();
    });

    this.fetchData();
  }

  private fetchUI() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  private fetchData() {
    // products
    const productsUrl = getProductsUrl(this.$store.state.lang, 11);
    axios.get(productsUrl).then((res: any) => {
      // window.console.log(res.data.proarr);
      this.products = res.data.proarr;
    });

    // 展会信息
    const exhibitionUrl = getExhibitionUrl(this.$store.state.lang, 6);
    axios.get(exhibitionUrl).then((res: any) => {
      // window.console.log(res.data);
      this.exhibitionInfos = res.data;
    });

    // 检测报告
    const testingUrl = getTestingUrl(this.$store.state.lang, 6);
    axios.get(testingUrl).then((res: any) => {
      // window.console.log(res.data);
      this.reportInfos = res.data;
    });

    // 相关资料
    const materialUrl = getMaterialUrl(this.$store.state.lang, 6);
    axios.get(materialUrl).then((res: any) => {
      // window.console.log(res.data);
      this.dataInfos = res.data;
    });

    // axios.get('/php/products.php?keyword=%E6%9C%8D%E8%A3%85&num=10').then((res: any) => {
    //   window.console.log(res.data.proarr);
    // });
  }

  private gotoProductlistPage() {
    this.$router.push('/productlist');
  }

  private playVideo() {
    // window.console.log('play-video');

    const audioPlayer = window.document.getElementById('videoPlay01') as HTMLVideoElement;
    audioPlayer.load();
    audioPlayer.play();
    this.showVideo = true;
  }

  private hideVideo() {
    // window.console.log('hide-video');
    const audioPlayer = window.document.getElementById('videoPlay01') as HTMLVideoElement;
    audioPlayer.pause();
    this.showVideo = false;
  }
}
